/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { MonitoredObjectsContext } from '../contexts/MonitoredObjectsContext';

export const useMonitoredObjectsStore = () => useContext(MonitoredObjectsContext);
